module.exports = __webpack_public_path__ + "static/turtle-creek-house05-c33d69a129b24cd75b750bf7962a7ccb.jpg";